export default __webpack_public_path__ + "img/2cb6382bf8ce75387dbf511909e97d29.png";